/* Up select inline CTA widget (汎用) — reads /products/{handle}.js, renders SOÉJU風 CTA,
   color->image+price, size grayout, cart-notification integration, bundle add, recommend carousel, GA4.
   build: 260703-10 (sjx: data-rank="" 明示空でRANKING節スキップ=rankingコレクションの出口用) */
(function(){
  "use strict";
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : "/";
  var yen = function(c){ return "¥" + (c/100).toLocaleString("ja-JP"); };
  // limit_by_2(選べる2枚セット)は表示価格を2倍にする（Shopify単価は1枚分のため）
  var isBy2 = function(p){ var t=p&&p.tags; return t?(Array.isArray(t)?t.indexOf("limit_by_2")>=0:String(t).indexOf("limit_by_2")>=0):false; };
  // CDNリサイズ付与（原寸配信は150-190KB/枚=記事重量の主因。既にwidth=付きならそのまま）
  var rsz = function(u,w){ if(!u) return u; u=String(u); if(u.indexOf("width=")>=0) return u; return u+(u.indexOf("?")>=0?"&":"?")+"width="+w; };
  var cache = {};
  function getProduct(handle){
    if(cache[handle]) return cache[handle];
    var req = fetch(ROOT + "products/" + handle + ".js", {headers:{"Accept":"application/json"}})
      .then(function(r){ if(!r.ok) throw new Error("404 "+handle); return r.json(); });
    // 失敗はキャッシュに残さない（一時的な通信エラーでページ寿命いっぱいウィジェットが消えるのを防ぐ）
    req.catch(function(){ if(cache[handle]===req) delete cache[handle]; });
    cache[handle] = req;
    return req;
  }
  function optMeta(p){
    var color=null,size=null;
    (p.options||[]).forEach(function(o,i){
      var nm=(typeof o==="object"?o.name:o)||"";
      var pos=(typeof o==="object"&&o.position)?o.position:(i+1);
      if(/カラー|色|color/i.test(nm)) color=pos;
      else if(/サイズ|size/i.test(nm)) size=pos;
    });
    if(!color && (p.options||[]).length>=2) color=2;
    if(!size && (p.options||[]).length>=1) size=1;
    return {color:color,size:size};
  }
  function ov(variant,pos){ return variant["option"+pos]; }
  function uniq(a){ var s=[],seen={}; a.forEach(function(x){ if(!seen[x]){seen[x]=1;s.push(x);} }); return s; }

  // カラー名→色玉(hex)。完全一致→部分一致ヒューリスティクス。未知はnull(画像スウォッチにフォールバック)。
  var COLOR_MAP={"クロ":"#1c1c1c","ブラック":"#1c1c1c","黒":"#1c1c1c","シロ":"#ffffff","ホワイト":"#ffffff","白":"#ffffff",
    "オフホワイト":"#f2eee5","アイボリー":"#ece2cd","生成り":"#ece2cd","ベージュ":"#d9c4a3","モカ":"#9c7b5e",
    "ブラウン":"#7a543a","茶":"#7a543a","キャメル":"#bd8b54","グレー":"#9b9b9b","杢グレー":"#a7a7a7","チャコール":"#494949",
    "コン":"#2a3148","ネイビー":"#2a3148","紺":"#2a3148","ブルー":"#5a7fae","青":"#5a7fae","サックス":"#9fb8d6",
    "ブルーグレー":"#869aa8","パープルグレー":"#8e8492","グレイッシュラベンダー":"#b1a6b8","ラベンダー":"#b3a4cf","パープル":"#7a6a93","紫":"#7a6a93",
    "オリーブ":"#6f6f3d","カーキ":"#7a7350","グリーン":"#5f7d5a","緑":"#5f7d5a","セージ":"#a3b18a","セージグリーン":"#a3b18a","ミント":"#a7cdb8","ピンク":"#e6b3bd","レッド":"#b23a3a","赤":"#b23a3a",
    "イエロー":"#e3c463","黄":"#e3c463","オレンジ":"#e08a3c","ボルドー":"#7a2f3a","ワイン":"#7a2f3a","テラコッタ":"#bd6a4a"};
  function colorHex(name){
    if(!name) return null;
    if(COLOR_MAP[name]) return COLOR_MAP[name];
    var keys=Object.keys(COLOR_MAP);
    for(var i=0;i<keys.length;i++){ if(name.indexOf(keys[i])>=0) return COLOR_MAP[keys[i]]; }
    return null;
  }

  function ga(name,detail){
    try{ if(window.gtag) window.gtag("event",name,detail||{});}catch(e){}
    try{ window.dataLayer=window.dataLayer||[]; window.dataLayer.push(Object.assign({event:name},detail||{})); }catch(e){}
  }

  var yenStr=function(c){return "¥"+(Math.round(c)/100).toLocaleString("ja-JP");};
  var mc=null;
  function ensureMiniCart(){
    if(mc) return mc;
    var ov=document.createElement("div"); ov.className="sjmc-ov";
    var pan=document.createElement("aside"); pan.className="sjmc"; pan.setAttribute("aria-label","カート");
    pan.innerHTML='<div class="sjmc-hd"><b>カートに追加しました</b><button class="sjmc-x" type="button" aria-label="閉じる">&times;</button></div>'+
                  '<div class="sjmc-body"></div>'+
                  '<div class="sjmc-ft"><div class="sjmc-sub"><span>小計</span><span class="sjmc-total"></span></div>'+
                  '<a class="sjmc-co" href="'+ROOT+'checkout">ご購入手続きへ</a>'+
                  '<a class="sjmc-view" href="'+ROOT+'cart">カートを見る</a></div>';
    document.body.appendChild(ov); document.body.appendChild(pan);
    function close(){ ov.classList.remove("open"); pan.classList.remove("open"); }
    ov.addEventListener("click",close); pan.querySelector(".sjmc-x").addEventListener("click",close);
    document.addEventListener("keydown",function(e){ if(e.key==="Escape") close(); });
    mc={ov:ov,pan:pan,close:close}; return mc;
  }
  function updateBubble(count){
    document.querySelectorAll(".cart-count-bubble span:not(.visually-hidden), #cart-icon-bubble .cart-count-bubble span, [data-cart-count]").forEach(function(e){
      if(/^\d+$/.test(e.textContent)||e.hasAttribute("data-cart-count")) e.textContent=count;
    });
  }
  function openMiniCart(){
    var m=ensureMiniCart();
    fetch(ROOT+"cart.js",{headers:{"Accept":"application/json"}}).then(function(r){return r.json();}).then(function(c){
      var body=m.pan.querySelector(".sjmc-body"); body.innerHTML="";
      c.items.forEach(function(it){
        var img=it.image? it.image.replace(/(\.[a-z]+)(\?|$)/,"_120x$1$2"):"";
        var v=(it.variant_title&&it.variant_title!=="Default Title")? '<div class="v">'+it.variant_title+'</div>':"";
        var li=document.createElement("div"); li.className="sjmc-li";
        li.innerHTML='<img src="'+img+'" alt=""><div><div class="t">'+it.product_title+'</div>'+v+
                     '<div class="v">数量 '+it.quantity+'</div><div class="p">'+yenStr(it.final_line_price)+'</div></div>';
        body.appendChild(li);
      });
      m.pan.querySelector(".sjmc-total").textContent=yenStr(c.total_price);
      updateBubble(c.item_count);
      m.ov.classList.add("open"); m.pan.classList.add("open");
    });
  }
  function addToCart(items){
    return fetch(ROOT+"cart/add.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({items:items})})
      .then(function(r){ return r.json().then(function(d){ if(!r.ok) throw new Error(d.description||d.message||"カートに追加できませんでした"); return d; }); })
      .then(function(d){ ga("add_to_cart",{currency:"JPY"}); openMiniCart(); return d; });
  }

  function el(tag,cls,html){ var e=document.createElement(tag); if(cls)e.className=cls; if(html!=null)e.innerHTML=html; return e; }

  // PC：マウスで掴んで横スクロール（基本設定＝全カルーセル共通。タッチはネイティブ）
  function enableDrag(scroll){
    if(!scroll || scroll.getAttribute("data-drag")) return; scroll.setAttribute("data-drag","1");
    var down=false,sx=0,sl0=0,moved=false,pid=null;
    scroll.style.cursor="grab";
    // 注意: setPointerCapture は「実際に4px動いてから」掛ける。
    // pointerdown で即captureすると click がカルーセルに吸われ、カード<a>のクリック遷移が死ぬ(PC)。
    scroll.addEventListener("pointerdown",function(e){ if(e.pointerType==="touch")return; down=true;moved=false;sx=e.clientX;sl0=scroll.scrollLeft;pid=e.pointerId; scroll.style.cursor="grabbing"; });
    scroll.addEventListener("pointermove",function(e){ if(!down)return; var dx=e.clientX-sx;
      if(!moved && Math.abs(dx)>4){ moved=true; scroll.style.scrollSnapType="none"; try{scroll.setPointerCapture(pid);}catch(_){} }
      if(moved) scroll.scrollLeft=sl0-dx; });
    function end(){ if(!down)return; down=false; scroll.style.cursor="grab"; scroll.style.scrollSnapType=""; }
    scroll.addEventListener("pointerup",end); scroll.addEventListener("pointercancel",end); scroll.addEventListener("pointerleave",end);
    scroll.addEventListener("click",function(e){ if(moved){ e.preventDefault(); e.stopPropagation(); moved=false; } },true);
    scroll.addEventListener("dragstart",function(e){ e.preventDefault(); });
  }
  // 横スクロール・カルーセルにトップページ風ドットを付与（スクロールバーの代わり）
  function addDots(scroll, tries){
    if(!scroll || scroll.getAttribute("data-dots")) return;
    var items=Array.prototype.slice.call(scroll.children);
    if(items.length<2) return;
    // CSS/画像適用前は scrollWidth が確定しないので、はみ出すまでリトライ(最大~4s)
    if(scroll.scrollWidth<=scroll.clientWidth+4){
      if((tries||0)<25) setTimeout(function(){ addDots(scroll,(tries||0)+1); }, 160);
      return;
    }
    scroll.setAttribute("data-dots","1");
    var dots=el("div","sj-dots");
    function stride(){ return items.length>1 ? (items[1].getBoundingClientRect().left-items[0].getBoundingClientRect().left) : (items[0].getBoundingClientRect().width||1); }
    items.forEach(function(it,i){
      var d=el("button","sj-dot"); d.type="button"; d.setAttribute("aria-label",(i+1));
      d.addEventListener("click",function(){ scroll.scrollTo({left:Math.round(i*stride()),behavior:"smooth"}); });
      dots.appendChild(d);
    });
    scroll.parentNode.appendChild(dots);
    enableDrag(scroll);
    function update(){
      var s=stride()||1; var idx=Math.round(scroll.scrollLeft/s);
      idx=Math.max(0,Math.min(items.length-1,idx));
      Array.prototype.forEach.call(dots.children,function(dot,j){ dot.setAttribute("aria-current", j===idx?"true":"false"); });
    }
    var raf; scroll.addEventListener("scroll",function(){ if(raf)cancelAnimationFrame(raf); raf=requestAnimationFrame(update); });
    window.addEventListener("resize",update);
    update();
  }

  function renderItem(node, p){
    var m=optMeta(p);
    var state={color:null,size:null,variant:null};
    var colors = m.color ? uniq(p.variants.map(function(v){return ov(v,m.color);})) : [null];
    var sizes  = m.size  ? uniq(p.variants.map(function(v){return ov(v,m.size);}))  : [null];
    var role = node.getAttribute("data-role")||"";
    var handle = p.handle;
    var cname = null;
    // 記事カード専用: data-img があれば商品メイン画像の代わりに指定画像を初期表示（PDP無変更で見せ方だけ差し替え）
    var forceImg = node.getAttribute("data-img") || "";

    function variantOf(color,size){
      return p.variants.filter(function(v){
        return (!m.color || ov(v,m.color)===color) && (!m.size || ov(v,m.size)===size);
      })[0];
    }
    function colorImg(color){
      var v=p.variants.filter(function(x){return ov(x,m.color)===color && x.featured_image;})[0];
      return v? v.featured_image.src : (p.featured_image||(p.images&&p.images[0]));
    }
    function sizeAvail(color,size){ var v=variantOf(color,size); return !!(v&&v.available); }

    node.innerHTML="";
    var ph=el("div","sj-ph"); var a=el("a"); a.href=ROOT+"products/"+handle;
    var img=el("img"); img.loading="lazy"; img.alt=p.title;
    a.appendChild(img); ph.appendChild(a);
    var head=el("div","sj-head"); var hinfo=el("div","sj-head-info"); var opts=el("div","sj-opts");
    if(role) hinfo.appendChild(el("span","sj-role",role));
    var nm=el("a","sj-nm",p.title); nm.href=ROOT+"products/"+handle;
    var pr=el("div","sj-pr");
    var colorsRow=el("div","sj-row"); var sizesRow=el("div","sj-row sj-sizes");
    var addBtn=el("button","sj-add","カートに追加"); addBtn.type="button";
    var note=el("div","sj-note","");
    hinfo.appendChild(nm); hinfo.appendChild(pr);

    // limit_by_2は2枚1セット販売（カート側で偶数チェックあり）＝価格表示×2・カート追加も2枚単位
    var by2qty=isBy2(p)?2:1;
    function setPrice(v){
      var base=(v?v.price:p.price)*by2qty;
      var cmp=v&&v.compare_at_price&&v.compare_at_price*by2qty>base?'<s>'+yen(v.compare_at_price*by2qty)+'</s>':'';
      pr.innerHTML=cmp+yen(base)+' <span class="tax">(税込)</span>';
    }
    function syncSizes(){
      Array.prototype.forEach.call(sizesRow.querySelectorAll(".sj-sz"),function(b){
        var sz=b.getAttribute("data-v");
        var ok = m.size? sizeAvail(state.color,sz) : true;
        b.disabled=!ok;
        if(!ok && state.size===sz){ state.size=null; b.setAttribute("aria-checked","false"); }
      });
    }
    function refreshVariant(){
      state.variant = variantOf(state.color,state.size) || null;
      var ready = (!m.size || state.size!=null) && (!m.color || state.color!=null) && state.variant && state.variant.available;
      addBtn.disabled = by2qty>1 ? false : !ready;  // by2はPDP誘導ボタンなので常に押せる
      if(state.variant){ img.src=rsz(state.variant.featured_image?state.variant.featured_image.src:colorImg(state.color),600); setPrice(state.variant); }
    }
    function pickColor(c){
      state.color=c;
      Array.prototype.forEach.call(colorsRow.querySelectorAll(".sj-sw"),function(s){ s.setAttribute("aria-checked", s.getAttribute("data-v")===c?"true":"false"); });
      if(cname) cname.textContent=c;
      img.src=rsz(colorImg(c),600);
      syncSizes();
      // 在庫のあるサイズを自動選択：未選択 or この色で在庫切れなら、在庫ありの先頭サイズへ（grey化を予防）
      if(m.size && (state.size==null || !sizeAvail(c,state.size))){
        var firstAvail=sizes.filter(function(s){ return sizeAvail(c,s); })[0];
        if(firstAvail){ pickSize(firstAvail); return; }
      }
      refreshVariant();
    }
    function pickSize(s){
      state.size=s;
      Array.prototype.forEach.call(sizesRow.querySelectorAll(".sj-sz"),function(b){ b.setAttribute("aria-checked", b.getAttribute("data-v")===s?"true":"false"); });
      refreshVariant();
    }

    if(m.color){
      colorsRow.appendChild(el("span","sj-lbl","色"));
      colors.forEach(function(c){
        var sw=el("button","sj-sw"); sw.type="button"; sw.setAttribute("data-v",c); sw.setAttribute("aria-checked","false");
        sw.title=c;
        var hx=colorHex(c);
        if(hx){ sw.style.backgroundColor=hx; if(/^#f|#ece|#ffffff/i.test(hx)) sw.style.borderColor="#cfcfcf"; }
        else { sw.style.backgroundImage="url("+rsz(colorImg(c),80)+")"; }
        sw.addEventListener("click",function(){ pickColor(c); ga("select_item_option",{handle:handle,option:"color",value:c}); });
        colorsRow.appendChild(sw);
      });
      cname=el("span","sj-cname",""); colorsRow.appendChild(cname);
      opts.appendChild(colorsRow);
    }
    if(m.size){
      sizesRow.appendChild(el("span","sj-lbl","サイズ"));
      sizes.forEach(function(s){
        var b=el("button","sj-sz",s); b.type="button"; b.setAttribute("data-v",s); b.setAttribute("aria-checked","false");
        b.addEventListener("click",function(){ if(b.disabled)return; pickSize(s); ga("select_item_option",{handle:handle,option:"size",value:s}); });
        sizesRow.appendChild(b);
      });
      opts.appendChild(sizesRow);
    }
    head.appendChild(ph); head.appendChild(hinfo);
    node.appendChild(head); node.appendChild(opts); node.appendChild(addBtn); node.appendChild(note);

    // defaults: 在庫のある先頭variantの色を選び、その色で在庫のあるサイズを自動選択（pickColor内）
    var def=p.variants.filter(function(v){return v.available;})[0]||p.variants[0];
    if(def){ if(m.color) pickColor(ov(def,m.color)); if(m.size && state.size==null) pickSize(ov(def,m.size)); }
    refreshVariant();
    setPrice(def);
    // data-img 指定時は初期表示だけ差し替え（色を選ぶと通常どおり色別画像へ切替＝挙動は不変）
    if(forceImg){ img.src=rsz(forceImg,600); }

    if(by2qty>1){
      // 選べる2枚セット: 2枚の組み合わせ選択はPDPにしか無いため、インライン追加ではなくPDPへ誘導(Take 260709)。
      // まとめ買い(sj-bundle)側は同色2枚のまま=_qty経由(PDPコピー「同じ色をストック買い」訴求と整合)
      addBtn.textContent="2枚の組み合わせを選ぶ →";
      addBtn.addEventListener("click",function(){
        ga("select_promotion",{handle:handle,from:"sj_item_by2"});
        location.href=ROOT+"products/"+handle+(state.variant?"?variant="+state.variant.id:"");
      });
    } else {
      addBtn.addEventListener("click",function(){
        note.textContent="";
        if(m.color && !state.color){ note.textContent="色を選んでください"; return; }
        if(m.size && !state.size){ note.textContent="サイズを選んでください"; return; }
        if(!state.variant || !state.variant.available){ note.textContent="この組み合わせは在庫切れです"; return; }
        addBtn.disabled=true; var orig=addBtn.textContent; addBtn.textContent="追加中…";
        addToCart([{id:state.variant.id,quantity:1}]).then(function(){
          addBtn.textContent="追加しました"; setTimeout(function(){addBtn.textContent=orig;addBtn.disabled=false;},1400);
        }).catch(function(e){ note.textContent=e.message; addBtn.textContent=orig; addBtn.disabled=false; });
      });
    }

    node._getSelected=function(){ return (state.variant&&state.variant.available)?state.variant.id:(def&&def.available?def.id:null); };
    node._qty=by2qty;
  }

  // 横並びカードの色ブロック高さをmax揃え=色数差(折返し)でサイズ行がずれるのを防ぐ
  function equalizeColorRows(cta){
    var rows=cta.querySelectorAll(".sj-item .sj-opts>.sj-row:not(.sj-sizes)");
    if(rows.length<2) return;
    var max=0;
    Array.prototype.forEach.call(rows,function(r){ r.style.minHeight=""; });
    Array.prototype.forEach.call(rows,function(r){ if(r.offsetHeight>max) max=r.offsetHeight; });
    Array.prototype.forEach.call(rows,function(r){ r.style.minHeight=max+"px"; });
  }
  var _eqrt; window.addEventListener("resize",function(){ clearTimeout(_eqrt); _eqrt=setTimeout(function(){ document.querySelectorAll(".sj-cta").forEach(equalizeColorRows); },200); });

  function initLooks(){
    document.querySelectorAll(".sj-cta").forEach(function(cta){
      var items=cta.querySelectorAll(".sj-item[data-handle]");
      var proms=[];
      items.forEach(function(node){
        proms.push(getProduct(node.getAttribute("data-handle"))
          .then(function(p){ renderItem(node,p); })
          .catch(function(){ node.style.display="none"; }));
      });
      Promise.all(proms).then(function(){ setTimeout(function(){ equalizeColorRows(cta); },60); });
      var bundle=cta.querySelector(".sj-bundle");
      if(bundle){
        bundle.addEventListener("click",function(){
          var ids=[]; items.forEach(function(n){ var id=n._getSelected&&n._getSelected(); if(id) ids.push({id:id,quantity:n._qty||1}); });
          if(!ids.length) return;
          bundle.disabled=true; var t=bundle.querySelector("span"); var orig=t?t.textContent:bundle.textContent;
          addToCart(ids).then(function(){ if(t)t.textContent="まとめて追加しました"; setTimeout(function(){ if(t)t.textContent=orig; bundle.disabled=false; },1500); ga("add_to_cart_bundle",{count:ids.length}); })
            .catch(function(){ bundle.disabled=false; });
        });
      }
    });
  }

  function initReco(){
    var sec=document.querySelector(".sj-reco[data-collection]"); if(!sec) return;
    // 出口(initExit)が hide-reco/reco 採用で .sj-reco を非表示にするページでは、描画されない分のfetch自体を省略(表示は同一)
    var sx=document.querySelector(".sjx[data-adopt]");
    if(sx){ var ad=(sx.getAttribute("data-adopt")||"").split(",");
      if(ad.indexOf("hide-reco")>=0||ad.indexOf("reco")>=0){ sec.style.display="none"; return; } }
    var handles=(sec.getAttribute("data-collection")||"").split(",").map(function(s){return s.trim();}).filter(Boolean);
    var exclude=(sec.getAttribute("data-exclude")||"").split(",").map(function(s){return s.trim();}).filter(Boolean);
    var want=parseInt(sec.getAttribute("data-count")||"6",10);
    var picked=[], seen={};
    exclude.forEach(function(h){seen[h]=1;});
    (function next(i){
      if(picked.length>=want || i>=handles.length){ render(); return; }
      fetchCollection(handles[i]).then(function(ps){
        ps.forEach(function(p){ if(picked.length<want && !seen[p.handle]){ seen[p.handle]=1; picked.push(p); } });
        next(i+1);
      });
    })(0);
    function render(){
      if(!picked.length){ sec.style.display="none"; return; }
      var scroll=sec.querySelector(".sj-rc-scroll");
      picked.forEach(function(p){
        var img=(p.images&&p.images[0]&&p.images[0].src)||"";
        var vp=(p.variants&&p.variants[0]); var price=vp?Math.round(parseFloat(vp.price)*100):0;
        var a=el("a","sj-rc"); a.href=ROOT+"products/"+p.handle;
        a.innerHTML='<img loading="lazy" src="'+img+'&width=320" alt="'+(p.title||"").replace(/"/g,"")+'">'+
          '<span class="sj-rc-nm">'+(p.title||"")+'</span><span class="sj-rc-pr">'+yen(price)+'</span>';
        a.addEventListener("click",function(){ga("select_promotion",{handle:p.handle,from:"article_reco"});});
        scroll.appendChild(a);
      });
      addDots(scroll);
    }
  }

  function initIndex(){
    document.querySelectorAll(".sj-ix[href^='#']").forEach(function(a){
      a.addEventListener("click",function(e){
        var t=document.querySelector(a.getAttribute("href")); if(!t)return;
        e.preventDefault(); t.scrollIntoView({behavior:"smooth",block:"start"});
        ga("select_content",{type:"look_index",target:a.getAttribute("href")});
      });
    });
    document.querySelectorAll(".sj-ix-scroll").forEach(addDots);
  }

  // ルックのヒーロー多角カルーセル（前→横→後ろ・実写）。
  // ドット＋◀▶矢印（PCクリック用）＋マウスドラッグスクロール（PCはoverflow-xを指で動かせない対策）。
  function initHero(){
    document.querySelectorAll(".lk-car").forEach(function(track){
      if(track.getAttribute("data-init")) return;
      var slides=Array.prototype.slice.call(track.children);
      if(slides.length<2) return;
      track.setAttribute("data-init","1");
      var box=track.parentNode;            // .lk-stage（画像ボックス＝矢印/バッジの基準）
      var outer=box.parentNode||box;       // .lk-img（ドットは画像の外＝この下に置く）
      function cur(){ return Math.round(track.scrollLeft/(track.clientWidth||1)); }
      function go(i){ i=Math.max(0,Math.min(slides.length-1,i)); track.scrollTo({left:Math.round((track.clientWidth||1)*i),behavior:"smooth"}); }
      // dots（画像の下に表示）
      var dots=el("div","lk-dots");
      slides.forEach(function(s,i){
        var d=el("button","lk-dot"); d.type="button"; d.setAttribute("aria-label",(i+1));
        if(i===0) d.setAttribute("aria-current","true");
        d.addEventListener("click",function(){ go(i); });
        dots.appendChild(d);
      });
      outer.appendChild(dots);
      // 矢印は無し（PCはドット＋マウスドラッグ、タッチはスワイプで操作）
      var raf;
      function update(){
        var idx=Math.max(0,Math.min(slides.length-1,cur()));
        Array.prototype.forEach.call(dots.children,function(dot,j){ dot.setAttribute("aria-current", j===idx?"true":"false"); });
      }
      track.addEventListener("scroll",function(){ if(raf)cancelAnimationFrame(raf); raf=requestAnimationFrame(update); },{passive:true});
      window.addEventListener("resize",update);
      update();
      // PCマウスドラッグ（共通enableDrag＝ドラッグ中inlineでsnap解除→確実に動く。release時CSSのmandatory復帰でスライド吸着）
      enableDrag(track);
    });
  }

  /* ═══════════ 記事出口改修 260702: 商品カード(sjp) + 末尾出口(sjx) ═══════════ */

  // 「【買う理由】商品名」を分解（【】=黒・商品名=グレーの強弱表示用）
  function splitBene(title){
    var m=/^(【[^】]+】)(.*)$/.exec(title||"");
    return m ? {b:m[1], rest:m[2]} : {b:"", rest:title||""};
  }
  function beneHTML(title){
    var s=splitBene(title);
    return (s.b?'<span class="nm-b">'+s.b+'</span>':'')+s.rest;
  }
  function pdpURL(handle, ref){ return ROOT+"products/"+handle+"?select_blog="+(ref||"card"); }
  function esc(s){ return (s||"").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/"/g,"&quot;"); }

  // 商品カード: <div class="sjp sjp-full|sjp-mini" data-handle data-cta data-sub data-desc data-chips="a|b" data-voice data-voice-label data-voice-meta>
  function initPCards(){
    document.querySelectorAll(".sjp[data-handle]").forEach(function(node){
      var handle=node.getAttribute("data-handle");
      var mini=node.classList.contains("sjp-mini");
      getProduct(handle).then(function(p){
        var img=(p.featured_image||(p.images&&p.images[0])||"");
        var cta=node.getAttribute("data-cta")||"この一枚を確かめる";
        var ref=mini?"mcard":"pcard";
        if(mini){
          node.innerHTML='<a class="sjp-m" href="'+pdpURL(handle,ref)+'">'+
            '<img loading="lazy" src="'+img+(img.indexOf("?")>=0?"&":"?")+'width=200" alt="">'+
            '<span class="sjp-mi"><span class="sjp-mn">'+beneHTML(p.title)+'</span>'+
            (node.getAttribute("data-voice")?'<span class="sjp-rev"><span class="st">'+esc(node.getAttribute("data-voice-label")||"")+'</span>'+esc(node.getAttribute("data-voice"))+'</span>':'')+
            '<span class="sjp-mx"><span class="pr">'+yen(isBy2(p)?p.price*2:p.price)+'</span><span class="go">'+esc(cta)+' →</span></span></span></a>';
        }else{
          var chips=(node.getAttribute("data-chips")||"").split("|").filter(Boolean)
            .map(function(c){return '<span class="sjp-chip">'+esc(c)+'</span>';}).join("");
          var voice=node.getAttribute("data-voice");
          var vhtml=voice?('<div class="sjp-voice"><p class="vh">'+esc(node.getAttribute("data-voice-label")||"STAFF VOICE")+'</p>'+
            '<p>'+esc(voice)+(node.getAttribute("data-voice-meta")?'<span class="vm"> — '+esc(node.getAttribute("data-voice-meta"))+'</span>':'')+'</p></div>'):'';
          var sub=node.getAttribute("data-sub");
          node.innerHTML='<a class="sjp-img" href="'+pdpURL(handle,ref)+'"><img loading="lazy" src="'+img+(img.indexOf("?")>=0?"&":"?")+'width=620" alt="'+esc(p.title)+'"></a>'+
            '<div class="sjp-body"><p class="sjp-name">'+beneHTML(p.title)+'</p>'+
            (node.getAttribute("data-desc")?'<p class="sjp-desc">'+esc(node.getAttribute("data-desc"))+'</p>':'')+
            (chips?'<div class="sjp-chips">'+chips+'</div>':'')+vhtml+
            '<a class="sjp-cta" href="'+pdpURL(handle,ref)+'">'+esc(cta)+' →</a>'+
            (sub?'<a class="sjp-sub" href="'+pdpURL(handle,ref)+'">'+esc(sub)+'</a>':'')+'</div>';
        }
        node.addEventListener("click",function(){ ga("select_promotion",{handle:handle,from:"article_"+ref}); });
      }).catch(function(){ node.style.display="none"; });
    });
  }

  // セクション見出し（トップページ .h 準拠）
  function sxHead(en,jp,ds){
    return '<div class="sjx-h"><div class="en">'+en+'</div><div class="jp">'+jp+'</div>'+(ds?'<div class="ds">'+ds+'</div>':'')+'</div>';
  }
  // limit既定24(利用側は最大でも数件+除外~10)・sessionStorage 10分キャッシュ・使用フィールドのみ保持。
  // products.json は body_html 込みで1回900KB級のため、ページ遷移ごとの再取得を抑える(260709 第三弾)
  function fetchCollection(h,limit){
    limit=limit||24;
    var url=ROOT+"collections/"+h+"/products.json?limit="+limit, k="sjc:"+url;
    try{ var c=JSON.parse(sessionStorage.getItem(k)||"0"); if(c&&c.t&&Date.now()-c.t<600000) return Promise.resolve(c.p); }catch(e){}
    return fetch(url,{headers:{"Accept":"application/json"}})
      .then(function(r){return r.json();}).then(function(d){
        var ps=(d.products||[]).map(function(p){ return {handle:p.handle,title:p.title,tags:p.tags,
          images:(p.images&&p.images[0])?[{src:p.images[0].src}]:[],
          variants:(p.variants&&p.variants[0])?[{price:p.variants[0].price}]:[]}; });
        try{ sessionStorage.setItem(k,JSON.stringify({t:Date.now(),p:ps})); }catch(e){}
        return ps;
      }).catch(function(){return [];});
  }
  function pj(p){ // products.json の price は "9800.00" 文字列
    var vp=(p.variants&&p.variants[0]); return vp?Math.round(parseFloat(vp.price)*100):0;
  }

  // 末尾出口: <div class="sjx" data-rank="ranking" data-rank-count="5" data-theme-collection data-theme-label data-exclude="h1,h2">
  //   <div class="sjx-worry-data" hidden><a data-handle data-q data-cta></a>…</div>
  //   <div class="sjx-read-data" hidden><a href data-x>タイトル</a>…</div></div>
  var LIFF="https://liff.line.me/2006380631-YnAnEqg5/cd5c6dad56db4c059a2aeb95dc6a9fb3";
  function initExit(){
    var sec=document.querySelector(".sjx"); if(!sec) return;
    // data-rank 属性なし=既定"ranking"、明示的に空("")ならRANKING節をスキップ（rankingコレクションの出口用）
    var rankCol=sec.hasAttribute("data-rank")?(sec.getAttribute("data-rank")||""):"ranking";
    var rankN=parseInt(sec.getAttribute("data-rank-count")||"5",10);
    var themeCol=sec.getAttribute("data-theme-collection")||"";;
      if(themeCol==="recommend"){ themeCol="all"; }  // recommendコレクションは未整備ページのため全アイテムに吸収 (Take 260704)
    var themeLabel=sec.getAttribute("data-theme-label")||"このテーマ";;
      if(themeCol==="all" && themeLabel==="おすすめのアイテム"){ themeLabel="すべてのアイテム"; }
    var exclude=(sec.getAttribute("data-exclude")||"").split(",").map(function(s){return s.trim();}).filter(Boolean);
    var worryEls=Array.prototype.slice.call(sec.querySelectorAll(".sjx-worry-data a"));
    var readEls=Array.prototype.slice.call(sec.querySelectorAll(".sjx-read-data a"));
    var adopt=(sec.getAttribute("data-adopt")||"").split(",");  // feature用: 既存 sj-reco / relnav を出口内の正位置へ移設

    // 汎用: sjx様式の商品カルーセル節（ランキングにも既存reco再構築にも使う）
    function carouselSec(en, jp, ds, cols, excl, count, ref, numbered, moreHTML){
      var box=el("div","sjx-sec"+(numbered?" sjx-rank":""),sxHead(en,jp,ds)+
        '<div class="sjx-carwrap"><div class="sjx-car"></div></div>'+(moreHTML||""));
      sec.appendChild(box);
      var scroll=box.querySelector(".sjx-car");
      var picked=[],seen={};
      excl.forEach(function(h){seen[h]=1;});
      (function next(i){
        if(picked.length>=count||i>=cols.length){ render(); return; }
        fetchCollection(cols[i]).then(function(ps){
          ps.forEach(function(p){ if(picked.length<count&&!seen[p.handle]){ seen[p.handle]=1; picked.push(p); } });
          next(i+1);
        });
      })(0);
      function render(){
        if(!picked.length){ box.style.display="none"; return; }
        picked.forEach(function(p,i){
          var img=(p.images&&p.images[0]&&p.images[0].src)||"";
          var a=el("a","sjx-pr");
          a.href=pdpURL(p.handle,ref);
          a.innerHTML='<span class="sjx-pimg">'+(numbered?'<span class="sjx-no">'+(i+1)+'</span>':'')+
            '<img loading="lazy" src="'+img+'&width=700" alt=""></span>'+
            '<span class="sjx-pnm">'+beneHTML(p.title)+'</span><span class="sjx-ppr">'+yen(isBy2(p)?pj(p)*2:pj(p))+'</span>';
          a.addEventListener("click",function(){ ga("select_promotion",{handle:p.handle,from:"article_"+ref}); });
          scroll.appendChild(a);
        });
        addDots(scroll);
      }
      return box;
    }

    // ① RANKING（rankCol空=スキップ）
    if(rankCol){
      carouselSec("RANKING","人気ランキング","どれにしようか迷ったら、まずはここから。",
        [rankCol],[],rankN,"rank",true,
        '<div class="sjx-more"><a href="'+ROOT+'collections/'+rankCol+'?select_blog=rank">'+(rankN+1)+'位以下も見てみる →</a></div>');
    }

    // feature: 旧レコメンド/関連ナビは非表示（PICK UPは悩み棚=worry-dataで統一、読み物はread-data）
    if(adopt.indexOf("hide-reco")>=0||adopt.indexOf("reco")>=0){
      var rc=document.querySelector(".sj-reco");
      if(rc) rc.style.display="none";
    }
    if(adopt.indexOf("hide-relnav")>=0){
      var rnv=document.querySelector(".relnav");
      if(rnv) rnv.style.display="none";
    }

    // ② PICK UP（悩み棚）。見出しは記事テーマごとに data-pick-jp / data-pick-ds で上書き可（C型の文脈出し分け）
    var pickJp=sec.getAttribute("data-pick-jp")||"同じ「気になる」から探す";
    var pickDs=sec.getAttribute("data-pick-ds")||"この記事で紹介しきれなかった、同じ悩みに応える一枚。";
    if(worryEls.length && themeCol){
      var pick=el("div","sjx-sec sjx-pick",sxHead("PICK UP",pickJp,pickDs)+
        '<div class="sjx-rows"></div><div class="sjx-more sjx-theme-more" style="display:none"><a href="'+ROOT+'collections/'+themeCol+'?select_blog=worry"></a></div>');
      sec.appendChild(pick);
      var rowsBox=pick.querySelector(".sjx-rows");
      // 行は同期で順序どおり生成し、fetch完了後に中身を埋める（完了順で並びが崩れないように）
      worryEls.forEach(function(w){
        var h=w.getAttribute("data-handle");
        var a=el("a","sjx-w"); a.href=pdpURL(h,"worry"); a.style.display="none";
        rowsBox.appendChild(a);
        getProduct(h).then(function(p){
          var img=(p.featured_image||(p.images&&p.images[0])||"");
          var s=splitBene(p.title);
          a.innerHTML='<span class="sjx-wi"><img loading="lazy" src="'+img+(img.indexOf("?")>=0?"&":"?")+'width=300" alt=""></span>'+
            '<span><span class="sjx-wq">「'+esc(w.getAttribute("data-q"))+'」</span>'+
            '<span class="sjx-wn">'+esc(s.rest)+'</span>'+
            '<span class="sjx-wx"><span class="pr">'+yen(isBy2(p)?p.price*2:p.price)+'</span><span class="go">'+esc(w.getAttribute("data-cta")||"この一枚を見る")+' →</span></span></span>';
          a.style.display="";
          a.addEventListener("click",function(){ ga("select_promotion",{handle:h,from:"article_worry"}); });
        }).catch(function(){ a.remove(); });
      });
      // 数字入り表現(残りのN枚等)は在庫変動で不整合リスクがあるため全廃 (Take 260704)
      fetchCollection(themeCol).then(function(ps){  // 「もっと見る」を出すかのboolean判定のみ(24件で除外~10件でも判定等価)
        var shown={}; exclude.forEach(function(h){shown[h]=1;});
        worryEls.forEach(function(w){shown[w.getAttribute("data-handle")]=1;});
        var rest=ps.filter(function(p){return !shown[p.handle];}).length;
        if(rest>0){
          var more=pick.querySelector(".sjx-theme-more");
          more.style.display="";
          more.querySelector("a").textContent=themeLabel+"を、もっと見てみる →";
        }
      });
    }

    // ③ READ MORE（あわせて読みたい＝Aboutの前・Take指定 7/3）
    if(readEls.length){
      var rows=readEls.map(function(r){
        return '<a class="sjx-art" href="'+r.getAttribute("href")+'"><span class="at">'+esc(r.textContent)+'</span>'+
          (r.getAttribute("data-x")?'<span class="ax">'+esc(r.getAttribute("data-x"))+'</span>':'')+'</a>';
      }).join("");
      sec.appendChild(el("div","sjx-sec",sxHead("READ MORE","あわせて読みたい","")+'<div class="sjx-arts">'+rows+'</div>'));
    }

    // ④ ABOUT（data-no-about="1" のページはスキップ: aboutページ自身など情報がだぶるため 260704）
    if(!sec.hasAttribute("data-no-about")){
    var about=el("div","sjx-sec",sxHead("ABOUT","Up select について","")+
      '<div class="sjx-brand">'+
      '<img class="lg" loading="lazy" src="'+ROOT.replace(/\/$/,"")+'/cdn/shop/files/logo_0.png?width=300" alt="Up select" onerror="this.style.display=\'none\'">'+
      '<p class="tag">忙しくても、品よく。</p>'+
      '<p class="copy">朝、鏡の前で迷う時間はなくても、ちゃんとして見られたい。Up select は、そんな忙しい大人女性のセレクトショップです。</p>'+
      // 約束チップス3行（確定コンセプト、トップ concept_band と同一文言 260704）
      '<div style="text-align:center;margin:2px 0 18px;"><div style="display:inline-block;text-align:left;">'+
      /* 260705 Take改稿「同世代の女性編集部」: 長文化でnowrapは390pxではみ出すため、折返し可+ぶら下げインデント(✓absolute)に変更 */
      ['「LINEメディア賞」女性部門を4年連続で受賞したHALMEK upが運営','“これなら間違いない”だけを、同世代の女性編集部が厳選','ご注文の約8割を、2日以内に発送','サイズ相談・返品は、スタッフがメール1本で'].map(function(t){
        return '<div style="font-size:13.5px;color:#444;letter-spacing:.04em;line-height:2.1;position:relative;padding-left:24px;"><span style="color:#b8a98c;font-weight:700;position:absolute;left:0;">✓</span>'+t+'</div>';
      }).join('')+
      '</div></div>'+
      '<a class="btn" href="'+ROOT+'pages/about?select_blog=brand#cc-selection">編集チームの選び方を見る →</a>'+
      '<a class="btn2" href="'+ROOT+'collections/all?select_blog=brand">すべてのアイテムから探す →</a></div>');
    sec.appendChild(about);
    }

    // ⑤ LINE（末尾1箇所のみ。data-no-line="1"はスキップ: LINE登録LP自身など情報がだぶるため 260704）
    if(!sec.hasAttribute("data-no-line"))
    sec.appendChild(el("div","sjx-line",
      '<p class="t">LINE友だち登録で<br>送料無料クーポン（¥550）プレゼント</p>'+
      '<p class="s">大人女性のおしゃれ情報も、LINE友だちだけにお届けします。</p>'+
      '<a href="'+LIFF+'">LINEで送料無料クーポンを受け取る →</a>'));

    // 使い終わった data ノードを掃除
    Array.prototype.forEach.call(sec.querySelectorAll(".sjx-worry-data,.sjx-read-data"),function(n){ n.remove(); });

    // テーマ標準の「← ブログ一覧に戻る」は残す（サイズ調整はCSS側 .sjx-shrink-back で実施）
    document.body.classList.add("sjx-on");
  }

  /* ═══════════ 商品写真バッジ 260722: 記事内の商品リンク写真に「押せる」印（白ピル+バッグ+商品を見る） ═══════════ */
  // 記事50/50 A/B: 記事handleのハッシュ偶奇で treated(バッジあり)/control(なし)。指標=記事→PDP遷移率。
  // バッジ経由タップは href に via=badge を付与して素の写真タップと分離計測。
  // ロールバック: boot() から initPhotoBadges() を外して upload_widget_assets.py 再実行。
  function bagSvg(color,size,cls){
    return '<svg viewBox="0 0 24 24" width="'+size+'" height="'+size+'" fill="none" stroke="'+color+'" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"'+(cls?' class="'+cls+'"':'')+'><path d="M6 8h12l1 12H5L6 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>';
  }
  var BADGE_SVG=bagSvg("#333",17,null);
  // 割当は訪問者単位50/50(localStorageで端末固定)。当初の記事handle分割は流入がべき乗分布で
  // 上位記事がほぼtreatedに偏り比較が成立しないため260722当日中に切替(記事内比較=記事差が消える)
  function badgeArm(){
    if(!/\/blogs\/[^\/]+\/[^\/?#]+/.test(location.pathname)) return null; // 記事ページ以外(コレクション出口等)は対象外
    var q=/[?&]upb=([01])/.exec(location.search);
    if(q){                                 // QA用の強制表示(?upb=1/0)。プレビュー=露出イベント発火なし
      try{ localStorage.setItem("upb_arm",q[1]); }catch(e){}
      return {treated:q[1]==="1",preview:true};
    }
    var t=null;
    try{ t=localStorage.getItem("upb_arm"); }catch(e){}
    if(t!=="1"&&t!=="0"){
      t=Math.random()<0.5?"1":"0";
      try{ localStorage.setItem("upb_arm",t); }catch(e){}
    }
    return {treated:t==="1"};
  }
  function initPhotoBadges(){
    var arm=badgeArm();
    if(!arm) return;
    var eligible=0,exposed=false;
    function scan(){
      document.querySelectorAll('a[href*="select_blog"]').forEach(function(a){
        if(a.getAttribute("data-upb")) return;
        var img=a.querySelector("img");
        if(!img) return;
        // 対象=本文の素の写真リンクと sjp-full カード写真のみ。up-card / sjp-m / sj-rc 等のカード類は除外
        if(!a.classList.contains("sjp-img")){
          if(a.className) return;
          var w=Math.max(parseInt(img.getAttribute("width")||"0",10)||0, img.width||0, img.clientWidth||0);
          if(w<300) return;                // サムネイル・小画像は対象外
        }
        a.setAttribute("data-upb","1");
        eligible++;
        if(!arm.treated) return;           // controlは露出計数のみ(表示なし)
        var add=function(){
          if(getComputedStyle(a).position==="static") a.style.position="relative";
          if(getComputedStyle(a).display==="inline") a.style.display="inline-block";
          var s=el("span","upb",BADGE_SVG);  // v2 260722: アイコン円のみ(文字はCTA側が担う・北欧型)
          s.addEventListener("click",function(){
            if(a.href.indexOf("via=badge")<0) a.href+=(a.href.indexOf("?")>=0?"&":"?")+"via=badge";
            ga("select_promotion",{from:"article_photo_badge"});
          });
          a.appendChild(s);
        };
        // 遅延読込(コーデ節など下方の写真)は未ロードだと2px高に付いて崩れる→ロード完了を待つ
        if(img.complete&&img.naturalWidth>0) add(); else img.addEventListener("load",add,{once:true});
      });
      if(arm.treated){
        // CTA=バッグアイコン+「商品を見る」に統一(treatedのみ・写真バッジと同一treatment)。
        // 根拠=ユーザーインタビュー260717-21: 文字はスキップされ、押せる場所は見た目で判断されている。
        // v2 260722: 凝った文言(〜を確かめる)より機能語が速い(Take)。文字の仕事はCTA側・写真は記号のみ(北欧型)
        document.querySelectorAll(".sjp-cta").forEach(function(b){
          if(b.getAttribute("data-upbi")) return; b.setAttribute("data-upbi","1");
          b.innerHTML=bagSvg("#fff",16,"upb-i")+"商品を見る →";
        });
        document.querySelectorAll(".sjp-m .go, .sjx-wx .go").forEach(function(b){
          if(b.getAttribute("data-upbi")) return; b.setAttribute("data-upbi","1");
          b.innerHTML=bagSvg("#1a1a1a",13,"upb-i")+"商品を見る →";
        });
      }
      // 露出イベント(対象写真が1枚以上ある記事のみ・pageviewあたり1回)。分母=このイベントのセッション
      if(eligible>0&&!exposed&&!arm.preview){
        exposed=true;
        ga(arm.treated?"photo_badge_view_t":"photo_badge_view_c",{eligible:eligible});
      }
    }
    scan(); setTimeout(scan,1200); setTimeout(scan,3500); // sjp/sjxは商品fetch後に描画されるため後追い走査
  }

  function boot(){
    if(window.__ctaWidgetBooted) return;  // 二重読込ガード(campaign LP等でscriptが2回入るケース 260704)
    window.__ctaWidgetBooted = true;
    initLooks(); initReco(); initIndex(); initHero(); initPCards(); initExit(); initPhotoBadges();
  }
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",boot); else boot();
})();
